export const environment = {
    "aws": {
        "Auth": {
            "authenticationFlowType": "USER_PASSWORD_AUTH",
            "cookieStorage": {
                "domain": ".examsoft.com",
                "expires": 365,
                "path": "/",
                "secure": true
            },
            "identityPoolId": "ap-southeast-1:9fe2e87c-87a7-4142-8044-3ba7364b8a44",
            "identityPoolRegion": "ap-southeast-1",
            "region": "ap-southeast-1",
            "userPoolId": "ap-southeast-1_j7ZO6WLeJ",
            "userPoolWebClientId": "42j964pglacjuodfj1coliu1bk"
        },
        "aws_appsync_authenticationType": "AWS_IAM",
        "aws_appsync_graphqlEndpoint": "https://sydsxawjlff2nisggom66s5e2y.appsync-api.ap-southeast-1.amazonaws.com/graphql",
        "aws_appsync_region": "ap-southeast-1",
        "oauth": {
            "domain": "cog003apsgprod.auth.ap-southeast-1.amazoncognito.com",
            "options": {
                "AdvancedSecurityDataCollectionFlag": true
            },
            "redirectSignIn": "https://examnow-sg.examsoft.com",
            "redirectSignOut": "https://examnow-sg.examsoft.com",
            "responseType": "code",
            "scope": [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin"
            ]
        }
    },
    "esLogin": "https://login-sg.examsoft.com/",
    "metadata": {
        "application_code": "Xnw",
        "geographic_code": "ap",
        "instance_index": "003"
    },
    "production": true,
    "urls": {
        "gatewayApiUrl": "https://169mb81ox0.execute-api.ap-southeast-1.amazonaws.com/examnow-prod",
        "institutionApiUrl": "https://cog003-api-prod.examsoft.com/institutions",
        "pltApiUrl": "https://plt003-api-prod.examsoft.com",
        "pltUrl": "https://plt003-ui-prod.examsoft.com"
    }
};